import React, { useCallback, useEffect, useMemo } from 'react'

import { Dialog as DialogComp } from '@sencha/ext-modern'

import { useInstData, useEventHandler } from 'tyan/public/hooks'
import FetchSpinner from './FetchSpinner'
import ErrorBoundary from 'tyan/public/components/ErrorBoundary'
import { DialogContext } from 'tyan/public/components/context'

// const centerMe = (s) => {
// 	const doCenterMe = () => {
// 		const top = window.pageYOffset || document.documentElement.scrollTop
// 		const left = window.pageXOffset || document.documentElement.scrollLeft
// 		const size = Ext.Element.getViewSize()

// 		s.setXY([
// 			left + (size.width - s.getSize().width) / 2,
// 			top + (size.height - s.getSize().height) / 2,
// 		])
// 	}

// 	setTimeout(doCenterMe)
// }

export const holding = { holding: false }

const Dialog = props => {
	const { title, onClose, component: Comp, compProps = {}, dialogProps: { closeMe, escape = false, showFetchSpinner, ...dialogProps } = {} } = props
	const { me, setState, me: { dialogID, state: {
		renderMe = true, showed = false
	} } } = useInstData(props, useMemo(() => ({ dialogID: `dialog-${Tyan.getUuid()}` }), []))

	useEffect(() => {
		closeMe && handleClose()
	}, [closeMe])

	useEffect(() => {
		const dealESC = ({ event: e }) => {
			if (e.cancelBubble || e.defaultPrevented || e.keyCode != Ext.event.Event.ESC || e.repeat || e.ctrlKey || e.shiftKey || e.altKey || e.metaKey)
				return true

			handleClose()
			e.stopPropagation()
			return false
		}

		if (escape) {
			Ext.getWin().on({ keydown: dealESC, priority: 100 })
			return () => Ext.getWin().un('keydown', dealESC)
		}
	}, [])

	useEffect(() => {
		if (!renderMe) {
			onClose()
			compProps.onClose && compProps.onClose()
			!me.closeCalled && compProps.onCancel && compProps.onCancel()
		}
	}, [renderMe, onClose, compProps.onClose, compProps.onCancel])

	// const handleInitialize = useCallback(() => setState({ showMe: true }), [])
	const handleInitialize = useCallback(() => {
		me.dialog
			? me.dialog.show()
			: setTimeout(handleInitialize)
	}, [])

	const handleShow = useCallback(() => {
		// console.warn('handleShow')
		holding.holding = false
		setTimeout(() => setState({ showed: true }))
	}, [])


	const handleHide = useCallback(() => {
		const { doDestroyComp } = me
		delete me.doDestroyComp

		doDestroyComp ? doDestroyComp() : handleCompDestroyed()
	}, [])

	const handleClose = useCallback(() => {
		// console.warn('handleClose1')
		holding.holding ? setTimeout(handleClose) : !me.closeCalled && (/* console.log('handleClose'),  */holding.holding = true, me.closeCalled = true, me.dialog.hide())
	}, [])

	const handleCompDestroyed = useCallback(() => {
		// console.log('handleCompDestroyed')
		holding.holding = false
		setState({ renderMe: false })
	}, [])

	const handleRegisterCompDestroyFunc = useCallback(fn => { me.doDestroyComp = fn }, [])

	// console.log('Dialog render', 'showMe', me.state.showMe, 'renderMe', me.state.renderMe, me.state, title)

	return renderMe && <DialogComp id={dialogID} ref={ref => ref && (/* window.dialog = */ me.dialog = ref.cmp)}
		displayed={false} title={title} header={!!title}
		layout='fit'/* 'hbox' */ minWidth='200' minHeight='200' maxWidth='95%' maxHeight='95%'
		closeAction="hide" /* draggable={false} */ maximizable={false} bodyPadding='10' overflow-y='auto' scrollable
		{...dialogProps}
		/* centered={false}  */ onInitialize={handleInitialize} /* onBeforeShow={centerMe}  */ onShow={handleShow} onHide={handleHide} /* onResize={centerMe} */
	>
		<ErrorBoundary onClose={handleClose}>
			{showed && <DialogContext.Provider value={{ dialog: me.dialog }}>
				<Comp  {...compProps} _dialogShowed={showed}
					onClose={handleClose}
					onCompDestroyed={handleCompDestroyed}
					onRegisterCompDestroyFunc={handleRegisterCompDestroyFunc}
				/>
			</DialogContext.Provider> || null}
		</ErrorBoundary>
		<FetchSpinner showMe={showFetchSpinner} />
	</DialogComp> || null
}

export default Dialog